import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29c949dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon icon-button delete-bounding-box" }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = { class: "spawnable-dot-annotation" }
const _hoisted_4 = { class: "type-container" }
const _hoisted_5 = { class: "type" }
const _hoisted_6 = { class: "mouse-linked-connection-lines" }

import {computed, onMounted, onUnmounted, PropType, Ref, ref, watch} from "vue";
import DotAnnotations from "@/components/frame/image/annotation/DotAnnotations.vue";
import {SSpatial2DBoundingBox} from "@/store/Spatial2DAnnotation/model/SSpatial2DBoundingBox";
import {
  AnnotatableImagesStoreManager
} from "@/store/Spatial2DAnnotation/manager/AnnotatableImagesStoreManager";
import {
  AnnotatableBodyPartDisplayParamsStoreManager
} from "@/store/Spatial2DAnnotation/manager/AnnotatableBodyPartDisplayParamsStoreManager";
import DraggableResizableElement from "@/lib/components/flexible/DraggableResizableElement.vue";
import {BoundingBoxShortcut} from "@/components/frame/image/annotation/type/BoundingBoxShortcut";
import {BoundingBoxShortcutType} from "@/components/frame/image/annotation/enum/BoundingBoxShortcutType";
import ShortcutsManager, {SPECIAL_SHORTCUT_CODE} from "@/lib/common/helpers/ShortcutsManager";
import {SSpatial2DDotAnnotation} from "@/store/Spatial2DAnnotation/model/SSpatial2DDotAnnotation";
import ConnectionLine from "@/components/frame/image/annotation/ConnectionLine.vue";
import {defaultAnnotatableBodyPartsDisplayParams} from "@/data/annotation/DefaultAnnotatableBodyPartsDisplayParams";
import {onElementResize} from "@/lib/common/utilities/DomUtilities";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'Spatial2DBoundingBox',
  props: {
  parentInstanceId: {
    type: String,
    required: true,
  },
  parentOverlayRef: {
    type: Object as PropType<Ref<HTMLElement>>,
    required: true,
  },
  boundingBox: {
    type: Object as PropType<SSpatial2DBoundingBox>,
    required: true
  },
  isSelected: {
    type: Boolean,
    required: true,
  },
  displayAnnotationsHolder: Boolean,
},
  emits: ["onBoundingBoxClicked", "onCursorEntersBoundingBox", "onCursorLeavesBoundingBox", "spawnNewDotAnnotation"],
  setup(__props, { emit: emits }) {

const props = __props

_useCssVars(_ctx => ({
  "190d699f": (_unref(borderColor)),
  "3311d446": (_unref(backgroundColor)),
  "3e7bb3c2": (cursorOnBoundingBoxY.value),
  "3e7bb3c4": (cursorOnBoundingBoxX.value),
  "2fc46828": (_unref(spawnableDotAnnotationColor))
}))






// Computing here makes the bounding box's content reactive, which wouldn't be possible if computed was on the catAnnotatedImages array

// ------------------------------
//  CSS
// ------------------------------

const borderColor = computed(() => {
  return props.isSelected ? "var(--hover)": "var(--annotation)";
});

const backgroundColor = computed(() => {
  return props.isSelected ? "var(--hover-very-transparent)": "transparent";
});

const zIndex = computed(() => {
  return props.isSelected ? "999999999999999": "0";
});

// ------------------------------
//  Delete
// ------------------------------

const deleteBoundingBox = () =>
{
  AnnotatableImagesStoreManager.removeBoundingBox(props.boundingBox);
}

// ------------------------------
//  Drag & Resize
// ------------------------------

const boundingBoxElement = ref();

const saveBoundingBoxDimensions = () =>
{
  if (boundingBoxElement.value)
  {
    console.log("Saving new bounding dimensions...");

    const top = Number(boundingBoxElement.value.drElement.offsetTop);
    const left = Number(boundingBoxElement.value.drElement.offsetLeft);
    const width = Number(boundingBoxElement.value.drElement.offsetWidth);
    const height = Number(boundingBoxElement.value.drElement.offsetHeight);

    AnnotatableImagesStoreManager.setBoundingBoxDimensions(
        (top / props.parentOverlayRef.offsetHeight) * 100,
        (left / props.parentOverlayRef.offsetWidth) * 100,
        (width / props.parentOverlayRef.offsetWidth) * 100,
        (height / props.parentOverlayRef.offsetHeight) * 100,
    );
  }

}

// ------------------------------
//  Selection
// ------------------------------

const spawnableDotAnnotationDisplayParams = computed(() => {
  return AnnotatableBodyPartDisplayParamsStoreManager.store.selected;
})

const spawnableDotAnnotationConnectionLinesParams = computed(() =>
{
  if (!spawnableDotAnnotationDisplayParams.value.length)
    return [];

  const index = defaultAnnotatableBodyPartsDisplayParams.findIndex(param => param.value === spawnableDotAnnotationDisplayParams.value[0].value);

  return defaultAnnotatableBodyPartsDisplayParams[index].connectionLines;
})

const spawnableDotAnnotationName = computed(() => {
  return spawnableDotAnnotationDisplayParams.value.length ? spawnableDotAnnotationDisplayParams.value[0].value : undefined;
})

const spawnableDotAnnotationColor = computed(() => {
  return spawnableDotAnnotationDisplayParams.value.length ? spawnableDotAnnotationDisplayParams.value[0].colorCode : undefined;
})

const onClick = () =>
{
  emits("onBoundingBoxClicked", props.boundingBox);
}

const onClickInTheMiddle = () =>
{
  if (props.isSelected && isCursorInsideBoundingBox.value)
  {
    if (spawnableDotAnnotationDisplayParams.value.length)
      emits("spawnNewDotAnnotation", spawnableDotAnnotationDisplayParams.value[0]);
  }
}

// ------------------------------
//  Cursor tracking inside the overlay and the boundingBox
// ------------------------------

const isCursorInsideBoundingBox = ref(false);
const cursorOnBoundingBoxY = ref();
const cursorOnBoundingBoxX = ref();

onMounted(() =>
{
  boundingBoxElement.value.drElementMiddle.addEventListener("mouseover", function()
  {
    isCursorInsideBoundingBox.value = true;
    emits("onCursorEntersBoundingBox", props.boundingBox.instanceId);
  });

  boundingBoxElement.value.drElement.addEventListener("mousemove", function(this: HTMLElement, event: MouseEvent)
  {
    if (isCursorInsideBoundingBox.value)
    {
      const rect = this.getBoundingClientRect();

      cursorOnBoundingBoxX.value = (event.pageX - rect.left) + "px";
      cursorOnBoundingBoxY.value = (event.pageY - rect.top) + "px";
    }

    forceConnectingLineRedraw.value++;
  });

  boundingBoxElement.value.drElementMiddle.addEventListener("mouseleave", function()
  {
    isCursorInsideBoundingBox.value = false;
    emits("onCursorLeavesBoundingBox", props.boundingBox.instanceId);
  });
})

// ------------------------------
//  Annotations deletion
// ------------------------------

const hoveredAnnotations: Ref<SSpatial2DDotAnnotation[]> = ref([]);

const onHoveredAnnotations = (annotations: SSpatial2DDotAnnotation[]) =>
{
  hoveredAnnotations.value = annotations;
}

const shortcuts: Ref<BoundingBoxShortcut[]> = computed(() =>
{
  const base = [
    {
      type: BoundingBoxShortcutType.DELETE_ANNOTATION_DOT,
      keyCode: SPECIAL_SHORTCUT_CODE.LEFT_CLICK,
      requiresCtrl: true,
    },
  ];

  return [
    ...base,
  ];
});

let shortcutHolderInstanceIds: string[] = [];

onMounted(() =>
{
  registerShortcuts();
})

onUnmounted(() => {
  shortcutHolderInstanceIds.forEach(shortcutHolderInstanceId => ShortcutsManager.unregister(shortcutHolderInstanceId));
})

const registerShortcuts = () =>
{
  shortcuts.value.forEach((shortcut) =>
  {
    shortcutHolderInstanceIds.push(ShortcutsManager.register(shortcut.keyCode, shortcut.requiresCtrl as boolean, shortcut.requiresAlt as boolean, shortcut.requiresShift as boolean,  () =>
    {
      switch (shortcut.type)
      {
        case BoundingBoxShortcutType.DELETE_ANNOTATION_DOT:
          deleteDotAnnotation();
          break;
      }
    }));
  })
}

const deleteDotAnnotation = () =>
{
  hoveredAnnotations.value.map(dotAnnotation => {
    AnnotatableImagesStoreManager.removeDotAnnotationOfInstanceIdAndTypeFromCurrentBoundingBox(dotAnnotation.instanceId, dotAnnotation.type);
  })
}


// ------------------------------
//  Connecting lines
// ------------------------------

const forceConnectingLineRedraw = ref(0);

watch(() => props.boundingBox.annotations, () => {
  setTimeout(() => forceConnectingLineRedraw.value++, 50);
})

watch(() => AnnotatableBodyPartDisplayParamsStoreManager.store.selected, () => {
  setTimeout(() => forceConnectingLineRedraw.value++, 50);
})

onMounted(() => {
  onElementResize(boundingBoxElement.value.drElement, () => forceConnectingLineRedraw.value++);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DraggableResizableElement, {
      "parent-container-ref": __props.parentOverlayRef,
      "start-height": __props.boundingBox.height,
      "start-width": __props.boundingBox.width,
      "start-top-position": __props.boundingBox.top,
      "start-left-position": __props.boundingBox.left,
      "z-index": _unref(zIndex),
      "class-name": "bounding-box",
      "is-draggable": true,
      "is-draggable-only-from-borders": true,
      "is-resizable": true,
      "is-disabled": !__props.isSelected,
      onOnClick: onClick,
      onOnClickInTheMiddle: onClickInTheMiddle,
      onOnDragResizeEnd: saveBoundingBoxDimensions,
      ref_key: "boundingBoxElement",
      ref: boundingBoxElement
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: require('@/lib/assets/img/icons/close.svg'),
            onClick: _withModifiers(deleteBoundingBox, ["stop"]),
            alt: "close popup"
          }, null, 8, _hoisted_2)
        ], 512), [
          [_vShow, __props.isSelected]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(spawnableDotAnnotationName)), 1)
          ])
        ], 512), [
          [_vShow, __props.isSelected && isCursorInsideBoundingBox.value && _unref(spawnableDotAnnotationName)]
        ])
      ]),
      _: 1
    }, 8, ["parent-container-ref", "start-height", "start-width", "start-top-position", "start-left-position", "z-index", "is-disabled"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(DotAnnotations, {
          "dot-annotations": __props.boundingBox.annotations,
          "parent-bounding-box": __props.boundingBox,
          "parent-overlay-ref": __props.parentOverlayRef,
          "force-connecting-line-redraw": forceConnectingLineRedraw.value,
          onOnHoveredAnnotations: onHoveredAnnotations
        }, null, 8, ["dot-annotations", "parent-bounding-box", "parent-overlay-ref", "force-connecting-line-redraw"]), [
          [_vShow, __props.displayAnnotationsHolder && __props.isSelected]
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(spawnableDotAnnotationConnectionLinesParams), (connectionLineParams, index) => {
        return (_openBlock(), _createBlock(ConnectionLine, {
          color: connectionLineParams.colorCode,
          "to-element-id": 'dot-annotation-' + __props.boundingBox.instanceId + '-' + connectionLineParams.connectedWith,
          "from-element-id": "cursor-follower",
          "force-redraw": forceConnectingLineRedraw.value,
          key: index
        }, null, 8, ["color", "to-element-id", "force-redraw"]))
      }), 128))
    ], 512), [
      [_vShow, __props.displayAnnotationsHolder && isCursorInsideBoundingBox.value && __props.isSelected]
    ])
  ], 64))
}
}

})